export default "__VITE_ASSET__51ab6a58__"